import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router } from '@angular/router';
import { Observable, of } from 'rxjs';

import {
  ACCOUNT_CAN_ACTIVATE_GUARD,
  ACCOUNT_CAN_MATCH_GUARD
} from '@core/guards/account.guard';
import {
  CLIENT_CAN_ACTIVATE_GUARD,
  CLIENT_CAN_MATCH_GUARD
} from '@core/guards/client.guard';
import {
  PROJECT_CAN_ACTIVATE_GUARD,
  PROJECT_CAN_MATCH_GUARD
} from '@core/guards/project.guard';
import { PermissionsService } from '@core/services/permissions.service';
import { PermissionsType } from '@shared/models/permissions-type';

export const TEMPLATES_CAN_ACTIVATE_GUARD: CanActivateFn =
  (): Observable<boolean> => {
    const router = inject(Router);
    const permissionsService = inject(PermissionsService);

    const hasAccount = ACCOUNT_CAN_ACTIVATE_GUARD();
    const hasClient = CLIENT_CAN_ACTIVATE_GUARD();
    const hasProject = PROJECT_CAN_ACTIVATE_GUARD();

    if (
      !hasAccount ||
      !hasClient ||
      !hasProject ||
      !hasPermissions(permissionsService)
    ) {
      void router.navigate(['/']);

      return of(false);
    }

    return of(true);
  };

export const TEMPLATES_CAN_MATCH_GUARD: CanMatchFn =
  (): Observable<boolean> => {
    const router = inject(Router);
    const permissionsService = inject(PermissionsService);

    const hasAccount = ACCOUNT_CAN_MATCH_GUARD();
    const hasClient = CLIENT_CAN_MATCH_GUARD();
    const hasProject = PROJECT_CAN_MATCH_GUARD();

    if (
      !hasAccount ||
      !hasClient ||
      !hasProject ||
      !hasPermissions(permissionsService)
    ) {
      void router.navigate(['/']);

      return of(false);
    }

    return of(true);
  };

const hasPermissions = (permissionsService: PermissionsService): boolean => {
  const allowedPermission = [PermissionsType.InspectionTemplateView];

  return permissionsService.hasPermissions(allowedPermission, undefined, false);
};
